import { Component, forwardRef, Input } from '@angular/core';
import { Output } from "@angular/core";
import { EventEmitter } from "@angular/core";
import { UploadedFile } from "../../app/app.models";
import { ApiService } from "../../services/api.service";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { UploadedFileInfo } from "../../app/app.interfaces";

export const enum ButtonStyle {
  Button = 'button',
  Paperclip = 'paperclip'
}

export const FILE_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => FileUpload),
  multi: true
};

@Component({
  selector: 'file-upload',
  providers: [FILE_VALUE_ACCESSOR],
  template: `    
    <div *ngIf="buttonStyle === buttonStyleButton" class="fileUploadContainer w-100 d-flex">
      
      <div class="uploading" *ngIf="uploading">
        <div class="spinner-container">
          <ion-spinner></ion-spinner>
        </div>
        <div class="filename">{{ uploadingFile?.name }}</div>
      </div>
      
      <attachment *ngIf="file" [file]="file">
        <div *ngIf="removeable" (click)="remove.emit()" class="remove">{{ removeBtnText }}</div>
      </attachment>
      
      <label class="upload" *ngIf="!file || changeable">        
        
        <span class="btn btn--ghost"  *ngIf="!uploading" [ngClass]="{'disabled': disabled}">{{ (file) ? changeBtnText:chooseBtnText }}</span>        
        <input type="file" name="file" [disabled]="disabled" (change)="uploadFile($event)" />
      </label>
      
      
    </div>
    <div *ngIf="buttonStyle === buttonStylePaperclip">
      <div *ngIf="uploading">
        <div class="spinner-container">
          <ion-spinner></ion-spinner>
        </div>
      </div>

      <label *ngIf="!uploading" class="upload">
        <span class="paperclip-icon" [ngClass]="{'disabled': disabled}"><icon name="paperclip-light" size="medium" color="primary"></icon></span>
        <input type="file" name="file" [disabled]="disabled" (change)="uploadFile($event)" />
      </label>
    </div>
  `
})
export class FileUpload implements ControlValueAccessor {
  
  @Input() changeBtnText: string = 'Change file';
  @Input() chooseBtnText: string = 'Choose file';
  @Input() buttonStyle: ButtonStyle;
  @Input() removeBtnText: string = '×';
  @Input() changeable: boolean = false;
  @Input() removeable: boolean = true;

	protected file: UploadedFile = null;
  protected fileType: string = 'file';

	protected disabled: boolean = false;

	protected uploading: boolean = false;
	protected uploadingFile: any = null;
  
  @Output() afterUpload: EventEmitter<UploadedFile> = new EventEmitter<UploadedFile>();
  @Output() beforeUpload: EventEmitter<void> = new EventEmitter<void>();
  @Output() clear: EventEmitter<void> = new EventEmitter<void>();
  @Output() remove: EventEmitter<void> = new EventEmitter<void>();
  @Output() error: EventEmitter<any> = new EventEmitter<any>();
  

  //Placeholders for the callbacks which are later providesd
  //by the Control Value Accessor
	protected onTouchedCallback: () => void;
	protected onChangeCallback: (_: any) => void;
	
	buttonStyleButton = ButtonStyle.Button;
	buttonStylePaperclip = ButtonStyle.Paperclip;

  constructor(private apiService: ApiService) {
  }


  //get accessor
  get value(): UploadedFile {    
    return this.file ? this.file : null;    
  };
  
  writeValue(uploadedFile: UploadedFile): void {
    if (this.file!= uploadedFile) {
      this.file = uploadedFile;
    }    
  }

  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
  
  doClear() {
    // this.currentFile.clear();
    this.file = null;
    this.clear.emit();
  } 

  uploadFile(event) {

    event.stopPropagation();

    const file: any = event.target.files[0];
    if (typeof file === 'undefined') return;

    this.uploading = true;
    this.uploadingFile = file;

    this.onTouchedCallback();
    this.beforeUpload.emit();

    this.apiService.uploadFile(file, this.fileType).then((tmpFile: UploadedFileInfo)=> {

      this.file = new UploadedFile(tmpFile.fileName, tmpFile.origFileName, tmpFile.extension, 'tmp');
      this.uploading = false;
      this.uploadingFile = null;

      this.onChangeCallback(this.file);
      this.afterUpload.emit(this.file);


    }).catch((err)=>{
      console.error(err);
      this.uploading = false;
      this.uploadingFile = null;
      this.error.emit(err);
    });
  }
}



// WEBPACK FOOTER //
// ./src/partials/upload/file-upload.ts